module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_02_off.3070055f.svg";